import type { EventListenerOptions } from './EventManager';
import type { SwimlaneEventListener, SwimlaneEvents } from './events';
import { useSwimlaneEventHandler } from './useSwimlaneEventHandler';
import { useSwimlanePrivateApi } from './useSwimlanePrivateApi';

export const useSwimlaneInternalEventHandler = <E extends SwimlaneEvents>(
  eventName: E,
  handler: SwimlaneEventListener<E>,
  options?: EventListenerOptions,
) => {
  const apiRef = useSwimlanePrivateApi();
  useSwimlaneEventHandler(apiRef, eventName, handler, options);
};
